import * as React from "react";
import { ButtonHTMLAttributes } from "react";
import { ButtonContainer, ButtonLoading } from "./Button.styled";
import { ButtonSize, ButtonTheme } from "../../../constants";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	children?: React.ReactNode;
	theme?: ButtonTheme;
	isLoading?: boolean;
	isWhite?: boolean;
	isFull?: boolean;
	size?: ButtonSize;
}

export const Button = ({
	children = null,
	isLoading = false,
	theme = ButtonTheme.GOLD,
	isWhite = false,
	isFull = false,
	size = ButtonSize.DEFAULT,
	...props
}: ButtonProps) => {
	return (
		<ButtonContainer theme={theme} isLoading={isLoading} isWhite={isWhite} isFull={isFull} size={size} {...props}>
			<ButtonLoading isLoading={isLoading} />
			{children}
		</ButtonContainer>
	);
};
